<template>
  <div>
    <div class="card mb-3">
      <div class="card-header">
        <i class="fa fa-sign-out fa-lg"></i> {{ $t('project.exit.form.title') }}
        <createButton name="exits_create" :title="$t('project.exit.create.title')"></createButton>
      </div>
      <div class="card-body">
        <errorMessage v-bind:message="error"></errorMessage>
        
        <div class="table-responsive">
          <table class="table table-bordered table-striped" id="dataTable" width="100%" cellspacing="0">
            <thead>
              <tr>
                <th>{{ $t('project.exit.form.project') }}</th>
                <th class="drop-down-filter">{{ $t('project.form.type') }}</th>
                <th class="drop-down-filter">{{ $t('project.form.companyStatus') }}</th>
                <th>{{ $t('project.exit.form.tri') }}</th>
                <th>{{ $t('project.exit.form.duration') }}</th>
                <th class="no-sort no-filter" width=100 v-if="canCreate || canDelete">&nbsp;</th>
              </tr>
            </thead>
            <tfoot>
              <tr>
                <th>{{ $t('project.exit.form.project') }}</th>
                <th class="drop-down-filter">{{ $t('project.form.type') }}</th>
                <th class="drop-down-filter">{{ $t('project.form.companyStatus') }}</th>
                <th>{{ $t('project.exit.form.tri') }}</th>
                <th>{{ $t('project.exit.form.duration') }}</th>
                <th class="no-sort no-filter" width=100 v-if="canCreate || canDelete">&nbsp;</th>
              </tr>
            </tfoot>
            <tbody>
              <tr v-for="entite in entites" v-bind:data-id="entite.id" :key="entite.id" @click="view(entite.id)" class="clickable-row">
                <td>{{entite.project.entreprise.name }}</td>
                <td>{{entite.project.aLaCarte ? $t('project.company.form.aLaCarte') : entite.project.projectTypeText }}</td>
                <td>
                  <div v-if="entite.project.companyStatus == 1">
                    <span :class="'companyStatus companyStatus_' + entite.project.companyStatus"></span>
                    {{entite.project.companyStatusText != "0" ? entite.project.companyStatusText : "" }}
                  </div>

                  <div v-if="entite.project.companyStatus == 0">
                    <span :class="'companyStatus exitReason_' + entite.project.reasonInactif"></span>
                    {{entite.project.reasonInactifText != "0" ? entite.project.reasonInactifText : "" }}
                  </div>
                </td>
                <td>{{entite.tri }}</td>
                <td>{{entite.duration }}</td>
                
                <td class="no-sort" align=center v-if="canCreate || canDelete">
                  <div v-if="entite.project.companyStatus ==1">
                    <a href="#"  v-if="canReallyCreate(entite)" v-bind:title="$t('form.edit_button')" v-on:click.stop="edit(entite.id)">
                      <span class="fa fa-lg fa-pencil"></span>
                    </a>
                     <a href="#" v-else v-bind:title="$t('form.edit_button')">
                      <span class="fa fa-lg fa-pencil text-muted"></span>
                    </a>
                    &nbsp;
                    <a class="text-danger" v-if="canReallyDelete(entite)" v-bind:title="$t('form.delete_button')" href="#" v-on:click.stop="deleteEntity(entite.id)">
                      <span class="fa fa-lg fa-trash"></span>
                    </a>
                     <a class="text-danger" v-else v-bind:title="$t('form.delete_button')">
                      <span class="fa fa-lg fa-trash text-muted"></span>
                    </a>
                  </div>

                  <div v-if="entite.project.companyStatus == 0">
                    <span class="fa fa-lg fa-pencil text-muted"></span>
                    &nbsp;
                    <span class="fa fa-lg fa-trash text-muted"></span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <projectStatusLegend></projectStatusLegend>
  
  </div>

</template>

<script>
import {ExitServiceClient} from '../../shared/service-clients/service-clients'
import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
import SearchMixin from '../../shared/Mixin/SearchMixin'
import moment from 'moment'
import ProjectStatusLegend from '../projects/ProjectStatusLegend'
import permission from '../../shared/permission'

export default {
  name: 'Exits',
  mixins: [SearchMixin],
  data() {
    return {
      serviceClient: ExitServiceClient,
    }
  },
  methods: {
    canReallyCreate: function(entite) {
      var validatePermission = 'Pages.Projects.Property.Create'
      if (entite.project.projectType == 1) validatePermission = 'Pages.Projects.Company.Create'

      return permission.checkPermission([validatePermission]) && this.canCreate
    },
    canReallyDelete: function(entite) {
      var validatePermission = 'Pages.Projects.Property.Delete'
      if (entite.project.projectType == 1) validatePermission = 'Pages.Projects.Company.Delete'

      return permission.checkPermission([validatePermission]) && this.canDelete
    },
    fetchData: function() {
      let service = ServiceFactory.create(this.serviceClient)
      let self = this

      let projectId = this.$route.params.project_id

      service
        .getAll(projectId, '', 0, 10000)
        .then(res => {
          self.entites = res.items
          self.showDataTable()
        })
        .catch(err => {
          self.error = self.getErrorMessage(err)
        })
    },
  },
  components: {
    ProjectStatusLegend,
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .dataTables_wrapper{
    padding: 0px;
  }
</style>




// WEBPACK FOOTER //
// src/components/Investment/Exit.vue